// extracted by mini-css-extract-plugin
module.exports = {"offcanvas-bottom":"event-info-offcanvas_offcanvas-bottom__QBdSG"};